import type { ApprovingInvoiceReportFormInputResponse } from 'ap-openapi';
import { isReportInvoiceFile } from './typeGuards';
import type { UnifiedDocument, UnifiedDocumentFile } from './types';

/**
 * Helper function to normalize invoice file to unified format
 */
export const normalizeInvoiceFile = (
  item: ApprovingInvoiceReportFormInputResponse
): UnifiedDocument | null => {
  const mfFile = item?.input_additional_values?.[0];
  if (!mfFile || !isReportInvoiceFile(mfFile)) return null;

  return {
    file: mfFile,
    title: mfFile.name,
  };
};

/**
 * Helper function to normalize business document to unified format
 */
export const normalizeBusinessDocument = (document: {
  mf_file?: UnifiedDocumentFile;
  document_title?: string;
  document_number?: string;
  document_type?: string;
}): UnifiedDocument | null => {
  if (!document.mf_file) return null;

  return {
    file: document.mf_file,
    title: document.document_title,
    document_number: document.document_number,
    document_type: document.document_type,
  };
};
